import { billingCounterTooltip } from '@/helpers/subscription';

import { InfoTooltip } from './info-tooltip';

export const BillingCounterTooltip = ({
  plan,
}: {
  plan: Parameters<typeof billingCounterTooltip>[0];
}) => (
  <InfoTooltip content={billingCounterTooltip(plan)} label="Payments info" />
);
